import { selectAll } from "@fruugo/utilities";
import { sendClickEvent } from "./google-analytics";

export const initGATrackingLinks = () => {
  const elements = selectAll<HTMLElement>(".js-track-click");
  if (!elements || elements.length < 1) return;

  elements.forEach((element) => {
    const { contentId, contentName, contentUrl } = element.dataset;
    if (!contentId) return;

    element.addEventListener("click", () =>
      sendClickEvent(contentId, contentName, contentUrl)
    );
  });
};
